import React, { useState, useEffect } from 'react';
import usePortalAuth from '../../../auth/usePortalAuth';

import InputBase from '@material-ui/core/InputBase';
import Input from '@material-ui/core/Input';
import Tooltip from '@material-ui/core/Tooltip';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import { withStyles, makeStyles } from '@material-ui/core/styles';

const NewSignUp = () => {
  const [formState, setFormState] = React.useState({
    password: '',
    verifiedPassword: '',
  });

  //----------Handle Password change/validation-----------//

  const [errorPasswordList, setErrorPasswordList] = useState([]);
  const [errorPassword, setErrorPassword] = useState();

  const [digits, setDigits] = useState();
  const [min, setMin] = useState();
  const [uppercase, setUppercase] = useState();
  const [lowercase, setLowercase] = useState();
  const [spaces, setSpaces] = useState();
  const [symbols, setSymbols] = useState();

  var passwordValidator = require('password-validator');
  var schema = new passwordValidator();
  schema
    .is()
    .min(8) // Minimum length 8
    .is()
    .max(100) // Maximum length 100
    .has()
    .uppercase() // Must have uppercase letters
    .has()
    .lowercase() // Must have lowercase letters
    .has()
    .digits(1) // Must have at least 1 digits
    .has()
    .not()
    .spaces() // Should not have spaces
    .has()
    .symbols(1)
    .is()
    .not()
    .oneOf(['Passw0rd', 'Password123']); // Blacklist these values

  const handlePasswordChange = (event) => {
    if (
      event.target.value != undefined &&
      event.target.value != null &&
      event.target.value != ' ' &&
      event.target.name === 'password'
    ) {
      let enteredPassword = event.target.value;

      if (enteredPassword != undefined && schema.validate(enteredPassword)) {
        setFormState({ ...formState, [event.target.name]: event.target.value });
        setErrorPassword(false);
        setErrorPasswordList([]);
      } else if (enteredPassword != undefined && !schema.validate(enteredPassword)) {
        //console.log(schema.validate(enteredPassword, { list: true }))
        setErrorPasswordList(schema.validate(enteredPassword, { list: true }));

        setErrorPassword(true);
      } else if (event.target.name === 'password' && event.target.value.length === 0) {
        setErrorPassword(false);
        setErrorPasswordList([]);
        setSpaces(false);
      }
    }
  };

  const showPasswordRulesNotMet = [];

  // --------Password Rules Tooltip--------//
  useEffect(() => {
    console.log(errorPasswordList);
    {
      if (errorPasswordList != [] && !errorPasswordList.includes('digits')) {
        setDigits(true);
        console.log('I just set digits to true');
      } else if (errorPasswordList.includes('digits')) {
        setDigits(false);
      }
    }

    {
      if (errorPasswordList != [] && !errorPasswordList.includes('min')) {
        setMin(true);
      } else if (errorPasswordList.includes('min')) {
        setMin(false);
      }
    }
    {
      if (errorPasswordList != [] && !errorPasswordList.includes('uppercase')) {
        setUppercase(true);
      } else if (errorPasswordList.includes('uppercase')) {
        setUppercase(false);
      }
    }

    {
      if (errorPasswordList != [] && !errorPasswordList.includes('lowercase')) {
        setLowercase(true);
      } else if (errorPasswordList.includes('lowercase')) {
        setLowercase(false);
      }
    }

    {
      if (errorPasswordList != [] && !errorPasswordList.includes('spaces')) {
        setSpaces(true);
      } else if (errorPasswordList.includes('spaces')) {
        setSpaces(false);
      }
    }

    {
      if (errorPasswordList != [] && !errorPasswordList.includes('symbols')) {
        setSymbols(true);
      } else if (errorPasswordList.includes('symbols')) {
        setSymbols(false);
      }
    }
  }, [errorPasswordList.length]);

  var finalPasswordList = (
    <List>
      {digits === false ? (
        <ListItem style={{ color: 'red' }}>
          <ErrorIcon id="passwordTooltipListIcon" /> must contain as least one number
        </ListItem>
      ) : digits === true ? (
        <ListItem style={{ color: 'green' }}>
          <CheckCircleIcon id="passwordTooltipListIcon" /> must contain as least one number
        </ListItem>
      ) : (
        <ListItem>must contain as least one number</ListItem>
      )}
      {min === false ? (
        <ListItem style={{ color: 'red' }}>
          <ErrorIcon id="passwordTooltipListIcon" /> must contain least eight characters
        </ListItem>
      ) : min === true ? (
        <ListItem style={{ color: 'green' }}>
          <CheckCircleIcon id="passwordTooltipListIcon" />
          must contain least eight characters
        </ListItem>
      ) : (
        <ListItem>must contain least eight characters</ListItem>
      )}
      {uppercase == false ? (
        <ListItem style={{ color: 'red' }}>
          <ErrorIcon id="passwordTooltipListIcon" /> must contain at least one uppercase letter
        </ListItem>
      ) : uppercase === true ? (
        <ListItem style={{ color: 'green' }}>
          <CheckCircleIcon id="passwordTooltipListIcon" />
          must contain at least one uppercase letter
        </ListItem>
      ) : (
        <ListItem>must contain at least one uppercase letter</ListItem>
      )}
      {lowercase === false ? (
        <ListItem style={{ color: 'red' }}>
          <ErrorIcon id="passwordTooltipListIcon" /> must contain at least one lowercase letter
        </ListItem>
      ) : lowercase === true ? (
        <ListItem style={{ color: 'green' }}>
          <CheckCircleIcon id="passwordTooltipListIcon" />
          must contain at least one lowercase letter
        </ListItem>
      ) : (
        <ListItem>must contain at least one lowercase letter</ListItem>
      )}
      {symbols === false ? (
        <ListItem style={{ color: 'red' }}>
          <ErrorIcon id="passwordTooltipListIcon" /> must contain at least one special character
        </ListItem>
      ) : symbols === true ? (
        <ListItem style={{ color: 'green' }}>
          <CheckCircleIcon id="passwordTooltipListIcon" />
          must contain at least one special character
        </ListItem>
      ) : (
        <ListItem>must contain at least one special character</ListItem>
      )}
      {spaces === false ? (
        <ListItem style={{ color: 'red' }}>
          <ErrorIcon id="passwordTooltipListIcon" /> must contain no spaces
        </ListItem>
      ) : spaces === true ? (
        <ListItem style={{ color: 'green' }}>
          <CheckCircleIcon id="passwordTooltipListIcon" />
          must contain no spaces
        </ListItem>
      ) : (
        <ListItem>must contain no spaces</ListItem>
      )}
    </List>
  );

  var finalVerifyPasswordList = (
    <List>
      {digits === false ? (
        <ListItem style={{ color: 'red' }}>
          <ErrorIcon id="passwordTooltipListIcon" /> must contain as least one number
        </ListItem>
      ) : digits === true ? (
        <ListItem style={{ color: 'green' }}>
          <CheckCircleIcon id="passwordTooltipListIcon" /> must contain as least one number
        </ListItem>
      ) : (
        <ListItem>must contain as least one number</ListItem>
      )}
      {min === false ? (
        <ListItem style={{ color: 'red' }}>
          <ErrorIcon id="passwordTooltipListIcon" /> must contain least eight characters
        </ListItem>
      ) : min === true ? (
        <ListItem style={{ color: 'green' }}>
          <CheckCircleIcon id="passwordTooltipListIcon" />
          must contain least eight characters
        </ListItem>
      ) : (
        <ListItem>must contain least eight characters</ListItem>
      )}
      {uppercase == false ? (
        <ListItem style={{ color: 'red' }}>
          <ErrorIcon id="passwordTooltipListIcon" /> must contain at least one uppercase letter
        </ListItem>
      ) : uppercase === true ? (
        <ListItem style={{ color: 'green' }}>
          <CheckCircleIcon id="passwordTooltipListIcon" />
          must contain at least one uppercase letter
        </ListItem>
      ) : (
        <ListItem>must contain at least one uppercase letter</ListItem>
      )}
      {lowercase === false ? (
        <ListItem style={{ color: 'red' }}>
          <ErrorIcon id="passwordTooltipListIcon" /> must contain at least one lowercase letter
        </ListItem>
      ) : lowercase === true ? (
        <ListItem style={{ color: 'green' }}>
          <CheckCircleIcon id="passwordTooltipListIcon" />
          must contain at least one lowercase letter
        </ListItem>
      ) : (
        <ListItem>must contain at least one lowercase letter</ListItem>
      )}
      {symbols === false ? (
        <ListItem style={{ color: 'red' }}>
          <ErrorIcon id="passwordTooltipListIcon" /> must contain at least one special character
        </ListItem>
      ) : symbols === true ? (
        <ListItem style={{ color: 'green' }}>
          <CheckCircleIcon id="passwordTooltipListIcon" />
          must contain at least one special character
        </ListItem>
      ) : (
        <ListItem>must contain at least one special character</ListItem>
      )}
      {spaces === false ? (
        <ListItem style={{ color: 'red' }}>
          <ErrorIcon id="passwordTooltipListIcon" /> must contain no spaces
        </ListItem>
      ) : spaces === true ? (
        <ListItem style={{ color: 'green' }}>
          <CheckCircleIcon id="passwordTooltipListIcon" />
          must contain no spaces
        </ListItem>
      ) : (
        <ListItem>must contain no spaces</ListItem>
      )}
    </List>
  );

  const [openTooltip, setOpenTooltip] = React.useState(false);
  var activeTextarea = document.activeElement;

  const checkPasswordActiveField = () => {
    console.log(activeTextarea.id);
    if (activeTextarea.id === 'password' && errorPassword === true) {
      setOpenTooltip(true);
    } else {
      setOpenTooltip(false);
    }
  };
  useEffect(() => {
    checkPasswordActiveField();
  }, [errorPasswordList.length]);

  console.log(errorPasswordList.length);
  console.log(digits);

  const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
      //backgroundColor: '#f5f5f9',
      backgroundColor: theme.palette.common.black,
      //color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 220,
      fontSize: theme.typography.pxToRem(14),
      border: '1px solid #dadde9',
    },
  }))(Tooltip);

  return (
    <div>
      <fieldset>
        <label>
          <HtmlTooltip
            title={finalPasswordList}
            open={openTooltip}
            onOpen={() => setOpenTooltip(true)}
            onClose={() => setOpenTooltip(false)}
            disableHoverListener
            placement="left"
            arrow
          >
            {errorPassword === true ? (
              <span id="textfieldTitle">
                Password
                <span style={{ color: 'red', padding: '5px' }}>
                  <LockOutlinedIcon />
                </span>
              </span>
            ) : errorPassword === false ? (
              <span id="textfieldTitle">
                Password
                <span style={{ color: 'green', padding: '5px' }}>
                  <LockOutlinedIcon />
                </span>
              </span>
            ) : (
              <span id="textfieldTitle">
                Password
                <span style={{ padding: '5px' }}>
                  <LockOutlinedIcon />
                </span>
              </span>
            )}
          </HtmlTooltip>

          <input
            name="password"
            id="password"
            class="field"
            type="password"
            //placeholder="Password"
            className="newUserInput"
            onChange={handlePasswordChange}
            required
          />
        </label>

        <br />

        <label>
          <HtmlTooltip
            title={finalVerifyPasswordList}
            open={openTooltip}
            onOpen={() => setOpenTooltip(true)}
            onClose={() => setOpenTooltip(false)}
            disableHoverListener
            placement="left"
            arrow
          >
            {errorPassword === true ? (
              <span id="textfieldTitle">
                Verify Password
                <span style={{ color: 'red', padding: '5px' }}>
                  <LockOutlinedIcon />
                </span>
              </span>
            ) : errorPassword === false ? (
              <span id="textfieldTitle">
                Verify Password
                <span style={{ color: 'green', padding: '5px' }}>
                  <LockOutlinedIcon />
                </span>
              </span>
            ) : (
              <span id="textfieldTitle">
                Verify Password
                <span style={{ padding: '5px' }}>
                  <LockOutlinedIcon />
                </span>
              </span>
            )}
          </HtmlTooltip>

          <input
            name="verifiedPassword"
            id="password"
            class="field"
            type="password"
            //placeholder="Password"
            className="newUserInput"
            onChange={handlePasswordChange}
            required
          />
        </label>
      </fieldset>
    </div>
  );
};
export default NewSignUp;
